import TeacherPostReviewListStore from './TeacherPostReviewListStore';
import { registerStore } from 'utils/registerStore';
import { rootStore } from 'stores/root/RootStore';
import TeacherPostReviewListContainer from './TeacherPostReviewListContainer';
import interfaceBridge from 'utils/interfaceBridge';
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'hooks/useRootStore';

// step 1 store 생성-등록, root가 필요한 경우 import 해서 사용
registerStore(
  'TeacherPostReviewListStore',
  new TeacherPostReviewListStore(rootStore),
);

// step 3 page component 선언
const TeacherPostReviewList = observer(() => {
  const userStore = useRootStore().userStore;
  const [title, setTitle] = useState('');

  useEffect(() => {
    if (userStore.myInfo) {
      if (userStore.isManager) {
        setTitle('글 검토');
      } else {
        setTitle('나의 검토 요청글');
      }
    }
  }, [userStore.isManager]);

  // step 5 상단 네비게이션 바 작동 선언
  useEffect(() => {
    interfaceBridge.setButtonIcon('left', 'back');
    interfaceBridge.setBtnEventHandler({
      left: () => {
        interfaceBridge.back();
      },
    });
  }, []);

  interfaceBridge.setTitle(title);

  return <TeacherPostReviewListContainer />;
});
export default TeacherPostReviewList;
